import { getNotificationContainer, showLoggerLogLevel } from '../notification-util';
/**
 * Shows the notificationStructure
 * @internal
 * @param notificationStructure - The NotificationStructure object
 * @param tagName - The tag name to create prefix for the design system provider & notificationStructure component
 * @returns
 * */
export const showToast = (notificationStructure, tagName) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    showLoggerLogLevel(notificationStructure);
    const tagPrefix = tagName.split('-')[0];
    const container = getNotificationContainer('notify-container', tagName);
    if (container) {
        container.style.position = 'fixed';
        switch ((_b = (_a = notificationStructure === null || notificationStructure === void 0 ? void 0 : notificationStructure.config) === null || _a === void 0 ? void 0 : _a.toast) === null || _b === void 0 ? void 0 : _b.position) {
            case 'top-left':
                container.style.top = '0';
                container.style.left = '0';
                break;
            case 'bottom-left':
                container.style.bottom = '0';
                container.style.left = '0';
                break;
            case 'bottom-right':
                container.style.bottom = '0';
                container.style.right = '0';
                break;
            default:
                container.style.top = '0';
                container.style.right = '0';
        }
    }
    const toastNotify = document.createElement(`${tagPrefix}-toast`);
    const toastTitle = document.createElement('div');
    toastTitle.setAttribute('slot', 'top');
    toastTitle.textContent = notificationStructure.title;
    const toastDetails = document.createElement('div');
    toastDetails.setAttribute('slot', 'content');
    toastDetails.textContent = (notificationStructure === null || notificationStructure === void 0 ? void 0 : notificationStructure.body) || '';
    const toastDate = document.createElement('div');
    toastDate.setAttribute('slot', 'date');
    toastDate.textContent = ((_c = notificationStructure === null || notificationStructure === void 0 ? void 0 : notificationStructure.createdAt) === null || _c === void 0 ? void 0 : _c.toLocaleTimeString()) || '';
    let toastBottom;
    if (((_e = (_d = notificationStructure === null || notificationStructure === void 0 ? void 0 : notificationStructure.config) === null || _d === void 0 ? void 0 : _d.toast) === null || _e === void 0 ? void 0 : _e.buttons) &&
        ((_h = (_g = (_f = notificationStructure === null || notificationStructure === void 0 ? void 0 : notificationStructure.config) === null || _f === void 0 ? void 0 : _f.toast) === null || _g === void 0 ? void 0 : _g.buttons) === null || _h === void 0 ? void 0 : _h.length)) {
        toastBottom = document.createElement('div');
        toastBottom.setAttribute('slot', 'bottom');
        notificationStructure.config.toast.buttons.forEach((button) => {
            const buttonElement = document.createElement(`${tagPrefix}-button`);
            buttonElement.textContent = button.placeholder || 'example placeholder';
            buttonElement.addEventListener('click', () => {
                const { details } = notificationStructure.config.toast;
                if (button.action) {
                    return button.action({
                        details,
                        buttonElement,
                        toastElement: toastNotify,
                    });
                }
            });
            if (button.appearance) {
                buttonElement.setAttribute('appearance', button.appearance);
            }
            toastBottom.appendChild(buttonElement);
        });
    }
    toastNotify.setAttribute('notify', ((_k = (_j = notificationStructure === null || notificationStructure === void 0 ? void 0 : notificationStructure.config) === null || _j === void 0 ? void 0 : _j.toast) === null || _k === void 0 ? void 0 : _k.type) || '');
    ((_m = (_l = notificationStructure === null || notificationStructure === void 0 ? void 0 : notificationStructure.config) === null || _l === void 0 ? void 0 : _l.toast) === null || _m === void 0 ? void 0 : _m.autoClose)
        ? toastNotify.setAttribute('auto-close', `${(_p = (_o = notificationStructure === null || notificationStructure === void 0 ? void 0 : notificationStructure.config) === null || _o === void 0 ? void 0 : _o.toast) === null || _p === void 0 ? void 0 : _p.autoClose}`)
        : '';
    ((_r = (_q = notificationStructure === null || notificationStructure === void 0 ? void 0 : notificationStructure.config) === null || _q === void 0 ? void 0 : _q.toast) === null || _r === void 0 ? void 0 : _r.closeTimeout)
        ? toastNotify.setAttribute('close-timeout', `${(_t = (_s = notificationStructure === null || notificationStructure === void 0 ? void 0 : notificationStructure.config) === null || _s === void 0 ? void 0 : _s.toast) === null || _t === void 0 ? void 0 : _t.closeTimeout}`)
        : '';
    toastNotify.appendChild(toastTitle);
    toastNotify.appendChild(toastDetails);
    toastNotify.appendChild(toastDate);
    if (toastBottom) {
        toastNotify.appendChild(toastBottom);
    }
    container.appendChild(toastNotify);
};
